import useWindowDimensions from "helpers/screen";
import ChangeIndicator from "../ChangeIndicator";
import CryptoIcon from "../CryptoIcon";
import "./style.scss";

const MarketsList = ({ }) => {
  const {width} = useWindowDimensions();

  return <div className="marketsList">
    <div className="titles">
      <p>Name</p>
      <p>Price</p>
      <p>24h Change</p>
      <p>24h Volume</p>
      <p>Market Cap</p>
    </div>
    <div className="table">
      {
        [0,0,0,0,0,0,0,0,0].map((item, i) => {
          return <div key={i} className="item">
            <div className="flex">
              <CryptoIcon symbol="BTC" size={16}/>
              <p className="tickerName">BTC-USDC</p>
            </div>
            <p className="price">$41,402</p>
            {
              width > 768 ?
              <ChangeIndicator change={{percentage:1.23, amount: 1040}}/>
              :
              <ChangeIndicator change={{percentage:1.23, amount: 1040}} showFull={false}/>
            }
           
            <p className="volume">$201,503,451</p>
            <p className="mcap">$668,306,689,203.33</p>
          </div>
        })
      }
    </div>
  </div>
}

export default MarketsList;